import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-map-3",
  "use": "icon-si-glyph-map-3-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-map-3\" id=\"icon-si-glyph-map-3\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1156</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(0.000000, 2.000000)\" fill=\"#434343\">\n            <path d=\"M11.035,11.581 L15.997,12.875 L15.997,1.415 L11.035,0.062 L11.035,11.581 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M6.021,12.965 L9.943,11.581 L9.943,0.062 L6.021,1.879 L6.021,12.965 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M0.042,11.118 L4.992,12.965 L4.992,1.879 L0.042,0.031 L0.042,11.118 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-map-3.svg
// module id = CCew
// module chunks = 62